import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import './officeagents.scss';
import { ReactComponent as Back } from '../../images/back.svg';
import Input from '../../components/Input/Input';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';

function OfficeAgents() {
  const navigate = useNavigate();
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  return (
    <>
      <Modal open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)}>
        <div className="mod2" style={{ maxWidth: '70vw' }}>
          <div className="mod2header">
            <div>
              <p>Coldwell Banker</p>
              <p>Campbell - Santa Clara, CA </p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModalOpen(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="contholder">
            <div>
              <p>
                Agent's Name: <span className="big">James Cannon</span>
              </p>
              <p>
                Agent's Number: <span className="big">(408) 453-434</span>
              </p>
              <p>
                Agent's Email: <span className="big">name@gmail.com</span>
              </p>
              <p>
                Agent's Office: <span className="big">Codewell Banker,Campbell</span>
              </p>
              <p style={{ color: 'var(--primary-color)' }}>
                Current Marketing Executive: <span className="big">Antony Piers</span>
              </p>
            </div>
            <div>
              <p>
                Latest Call: <span className="big">Thursday, 16th Feb, 2022 @ 02:22PM</span>
              </p>
              <p>
                Status of call:{' '}
                <span className="big" style={{ color: 'var(--primary-color)' }}>
                  {' '}
                  Did Not Answer
                </span>
              </p>
              <p>
                Next Call/ Schedule: <span className="big">Thursday, 16th Feb, 2022 @ 02:22PM</span>
              </p>
            </div>
          </div>
          <div className="lorem">
            <p>Comment</p>
            <p>
              Hello ____________________ my name is____________________ with BPO Homes Tech.
              <br />
              <br />
              Some Agents in your office will be joining us today at __2____pm and at __2_____pm tomorrow for a short
              online meeting so they can learn how we can help gain them Listings and boost their business as everyone
              wants to get off to a fast start for 2023.
              <br />
              We would like to get 10 to 15 minutes of your time and show you how we can assist with the growth of your
              business. Can I invite you to one of the short meetings or if you even have a few minutes right now so I
              can show you how we can assist with helping you obtain some new listings?
            </p>
          </div>
        </div>
      </Modal>
      <div className="officeagents">
        <div className="ofnav">
          <form>
            <Input placeholder="Enter Assignee’s Name" />
            <Button
              style={{
                width: '70px',
                fontSize: '16px',
                padding: '5px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
                marginTop: 'unset',
              }}
              text="Filter"
              // onClick={() => setAddNewModalOpen(true)}
            />
          </form>
          <div>
            <Back onClick={() => navigate(-1)} />
            <div>
              <p>Coldwell Banker Real Estate LLC</p>
              <span>124 Rancho Del Mar, Aptos, CA 95003</span>
            </div>
          </div>
        </div>
        <div className="itemholder">
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
          <Item onClick={() => setDetailsModalOpen(true)} />
        </div>
      </div>
    </>
  );
}

export default OfficeAgents;

const Item = ({ name, onClick }) => {
  return (
    <div className="item" onClick={onClick}>
      <p>Agent's Name</p>
      <p>Contact Number</p>
    </div>
  );
};
